export default "__VITE_ASSET__e5ea6670__"